import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.includes.js";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
import { doLogout } from "@wkWebSrc/js/components/loginAPI";
import { encodeCookie } from "@utils/CookieUtils";
import { useUtilities } from "@wkComposables/useUtilities";
import { defineComponent } from "vue";
import { isEmail } from "@wkWebSrc/js/widgets/avm/avm-validation";
import { mapState } from "pinia";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
var PAGES;
(function (PAGES) {
  PAGES[PAGES["PROFILE"] = "/".concat(window.profileMenuData.urls.profile)] = "PROFILE";
  PAGES[PAGES["FAVOURITES"] = "/".concat(window.profileMenuData.urls.favourites)] = "FAVOURITES";
  PAGES[PAGES["REQUESTS"] = "/".concat(window.profileMenuData.urls.requests)] = "REQUESTS";
  PAGES[PAGES["SAVEDSEARCHES"] = "/".concat(window.profileMenuData.urls.savedSearches)] = "SAVEDSEARCHES";
  PAGES[PAGES["VALUATIONS"] = "/".concat(window.profileMenuData.urls.valuations)] = "VALUATIONS";
  PAGES[PAGES["LISTINGS"] = "/".concat(window.profileMenuData.urls.listings)] = "LISTINGS";
})(PAGES || (PAGES = {}));
export default defineComponent({
  name: "ProfileMenu",
  components: {
    BaseIcon
  },
  props: {
    profileImg: {
      type: String
    },
    profileName: {
      type: String,
      default: "Utente"
    },
    selectedPage: {
      type: String,
      default: PAGES.PROFILE
    },
    labels: {
      type: Object,
      required: true
    },
    urls: {
      type: Object,
      required: true
    }
  },
  setup() {
    var {
      redirectTo
    } = useUtilities();
    return {
      redirectTo
    };
  },
  data() {
    return {
      inWhatPage: null,
      activeHoverOfPage: null,
      isEmailVerified: null,
      profilePages: [{
        activeIcon: "user_profile_selected.svg",
        inactiveIcon: "user_profile-black.svg",
        text: this.labels.publicAreaProfile,
        link: "/" + this.urls.profile
      }, {
        activeIcon: "user_favourite_menu_selected.svg",
        inactiveIcon: "user_favourite.svg",
        text: this.labels.publicAreaFavourites,
        link: "/" + this.urls.favourites
      }, {
        activeIcon: "user_request_selected.svg",
        inactiveIcon: "user_request.svg",
        text: this.labels.publicAreaRequests,
        link: "/" + this.urls.requests
      }, {
        activeIcon: "user_saved_search_selected.svg",
        inactiveIcon: "user_saved_search.svg",
        text: this.labels.publicAreaSavedSearches,
        link: "/" + this.urls.savedSearches
      }, {
        activeIcon: "user_valuation_selected.svg",
        inactiveIcon: "user_valuation.svg",
        text: this.labels.publicAreaValuations,
        link: "/" + this.urls.valuations
      }, {
        activeIcon: "listings-star-blue.svg",
        inactiveIcon: "listings-star-black.svg",
        text: this.labels.publicAreaListings,
        link: "/" + this.urls.listings
      }]
    };
  },
  computed: Object.assign({
    profileUrl() {
      return window["_baseURL"];
    },
    enumPages() {
      return PAGES;
    }
  }, mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter"])),
  created() {
    this.checkPage(this.selectedPage);
    this.isEmailVerified = window.isEmailVerifiedFromController;
  },
  methods: {
    isEmail,
    logoutUser() {
      doLogout().then(() => {
        encodeCookie("googleOnetapCooldown", {
          time: Date.now()
        });
        location.href = window.location.origin;
      });
    },
    checkPage(page) {
      switch (page) {
        case "/".concat(window.profileMenuData.urls.profile, "/"):
          this.inWhatPage = this.enumPages.PROFILE;
          break;
        case "/".concat(window.profileMenuData.urls.favourites):
          this.inWhatPage = this.enumPages.FAVOURITES;
          break;
        case "/".concat(window.profileMenuData.urls.requests):
          this.inWhatPage = this.enumPages.REQUESTS;
          break;
        case "/".concat(window.profileMenuData.urls.savedSearches):
          this.inWhatPage = this.enumPages.SAVEDSEARCHES;
          break;
        case "/".concat(window.profileMenuData.urls.valuations):
          this.inWhatPage = this.enumPages.VALUATIONS;
          break;
        case "/".concat(window.profileMenuData.urls.listings):
          this.inWhatPage = this.enumPages.LISTINGS;
          break;
        default:
          // only case with parameters is "/?Ordinamento" from favourites
          var url = window.location.href;
          if (url.includes("?")) {
            this.inWhatPage = this.enumPages.FAVOURITES;
          } else {
            this.inWhatPage = this.enumPages.PROFILE;
          }
      }
    },
    customRedirectTo(pageLink) {
      if (this.inWhatPage === pageLink) return;else {
        this.redirectTo(this.profileUrl + pageLink);
      }
    }
  }
});